import { Tag } from "primereact/tag";
import { ReactNode } from "react";
import { IconLive } from "../../../../../layout/components/Icons";
import { ANNOUNCEMENT_STATUSES } from "../../../../constants";

const STATUS_CONFIG: Record<
    string,
    { className: string; icon: string | ReactNode }
> = {
    [ANNOUNCEMENT_STATUSES.LIVE]: {
        className: "bg-primary-default text-primary-text",
        icon: (
            <span className="mr-1 animate-pulse">
                <IconLive />
            </span>
        ),
    },
    [ANNOUNCEMENT_STATUSES.ACTIVE]: {
        className:
            "bg-transparent border border-success-default text-success-default",
        icon: "pi pi-check",
    },
    [ANNOUNCEMENT_STATUSES.DRAFT]: {
        className:
            "bg-transparent border border-info-default text-info-default",
        icon: "pi pi-pencil",
    },
    [ANNOUNCEMENT_STATUSES.ARCHIVED]: {
        className:
            "bg-transparent border border-default text-default opacity-60",
        icon: "pi pi-box",
    },
};

const StatusFilterTemplate = (props: { type: string; label: string }) => {
    const { type, label } = props;

    const config = STATUS_CONFIG[type];

    if (!config) {
        return <Tag className="whitespace-nowrap" value={label} rounded />;
    }

    return (
        <Tag
            rounded
            icon={config.icon}
            className={`${config.className} whitespace-nowrap`}
            value={label}
        />
    );
};

export default StatusFilterTemplate;
